import { SearchIcon } from 'lucide-react';

import { defineModule } from '@/shared/registry/types';

import { searchCommandSources } from './commands';

/**
 * `search` module: global search (docs/modules/search.md) — `/search?q=&module=&page=` with module filter,
 * highlighted snippets and pages, and live results grouped by module in the ⌘K palette. Modules may render their hits
 * themselves through `OrbitaModule.searchRenderers[entityType]`.
 */
export const module = defineModule({
  id: 'search',
  routes: [
    { path: 'search', lazy: async () => ({ Component: (await import('./pages/SearchPage')).default }) },
  ],
  nav: [
    {
      id: 'search',
      labelKey: 'search:nav.title',
      icon: SearchIcon,
      to: '/search',
      order: 20,
      section: 'primary',
    },
  ],
  commands: searchCommandSources,
});
